import createLucideIcon from '../createLucideIcon';

const Video = createLucideIcon('Video', [
  ['path', { d: 'm22 8-6 4 6 4V8Z', key: '50v9me' }],
  [
    'rect',
    {
      width: '14',
      height: '12',
      x: '2',
      y: '6',
      rx: '2',
      ry: '2',
      key: '1rqjg6',
    },
  ],
]);

export default Video;
